import { useEffect, useState } from "react";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { TimePickerIcon } from "themes/Icon";
import "./time_picker_comp.scss";

dayjs.extend(customParseFormat);

function TimePickerComp({
  date,
  onChange,
  className,
  defaultValue,
  placeholder = "Select time",
  disabled,
}) {
  const currentDateTime = dayjs();

  const [timeValue, setTimeValue] = useState(
    defaultValue ? dayjs(defaultValue, "hh:mm A") : null
  );

  const handleTimeChange = (time) => {
    if (onChange) {
      const time12HourFormat = time ? time.format("hh:mm A") : null;
      const time24HourFormat = time ? time.format("HH:mm") : null;

      onChange(time, time12HourFormat, time24HourFormat);
    }
    setTimeValue(time);
  };

  const parsedDate = dayjs(date, "DD-MM-YYYY");

  const disabledTime = () => {
    if (parsedDate.isSame(currentDateTime, "day")) {
      const currentHour = currentDateTime.hour();
      const currentMinute = currentDateTime.minute();

      return {
        disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
        disabledMinutes: (hour) => {
          if (hour === currentHour) {
            return Array.from({ length: currentMinute }, (_, i) => i);
          }
          return [];
        },
        disabledSeconds: () => [],
      };
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    };
  };

  const handleClearTime = () => {
    setTimeValue(null);
  };

  useEffect(() => {
    if (!defaultValue) {
      handleClearTime();
    }
  }, [date]);

  return (
    <TimePicker
      disabled={disabled}
      value={timeValue}
      suffixIcon={<TimePickerIcon />}
      className={`time-picker-comp ${className}`}
      placeholder={placeholder}
      format="hh:mm A"
      use12Hours
      showSecond={false}
      popupClassName="time-picker-popup"
      onChange={handleTimeChange}
      defaultOpenValue={dayjs("12:00 AM", "hh:mm A")}
      disabledTime={disabledTime}
    />
  );
}

export default TimePickerComp;
